import { Link, useHistory } from "react-router-dom";
import React, { useCallback, useContext, useEffect, useState } from "react";
import "moment/locale/fr";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { UserContext } from "../../App";
import { getSubscriptionCheckoutSecret } from "../../utils/subscription";

const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const stripePromise = loadStripe(stripePublicKey);

export default function SubscriptionContent() {
  const { userInfos } = useContext(UserContext);
  const [checkoutSecret, setCheckoutSecret] = useState("");
  const history = useHistory();

  const fetchData = useCallback(async () => {
    if (!userInfos.jwt) return;
    const secret = await getSubscriptionCheckoutSecret(userInfos.jwt);

    if (!secret) {
      history.push("/profile");
    } else {
      setCheckoutSecret(secret);
    }
  }, [history, userInfos.jwt]);

  // Init booking datas
  useEffect(() => {
    if (!checkoutSecret) fetchData().then();
  }, [checkoutSecret, fetchData]);

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main"></div>
        </div>
      </div>
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head py-2 px-4" style={{minHeight: "0"}}>
            <div className="kt-portlet__head-label w-100 d-flex flex-column align-items-start">
              <h3 className="kt-portlet__head-title">Payer l'abonnement</h3>
              <span>
                Ou{" "}
                <Link to="/" style={{ color: "blue" }}>
                  continuer à utiliser la période d'essai (
                  {userInfos.subscriptionInfos?.trialRemainingDays}j)
                </Link>
              </span>
            </div>
          </div>
          {userInfos.subscriptionInfos?.tryPeriodAvailable ? (
            <div className="ms-4 mt-2">
              <p>
                En validant ce paiement, je reconnais avoir lu et accepté les{" "}
                <a
                  href="https://zeplan.ai/informations-legales/cgv/"
                  rel="noreferrer"
                  target="_blank"
                >
                  CGV
                </a>
                .
              </p>
            </div>
          ) : null}
          <div className="mb-4">
            {checkoutSecret && stripePromise && (
              <div>
                <EmbeddedCheckoutProvider
                  stripe={stripePromise}
                  options={{
                    clientSecret: checkoutSecret,
                  }}
                >
                  <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
